var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36035 10.9062C9.46492 10.9062 10.3604 10.0108 10.3604 8.90625C10.3604 7.80168 9.46492 6.90625 8.36035 6.90625C7.25578 6.90625 6.36035 7.80168 6.36035 8.90625C6.36035 10.0108 7.25578 10.9062 8.36035 10.9062Z",
    fill: "#14AE5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0272 8.23828H13.6478C13.4981 7.06526 12.9631 5.97516 12.1268 5.1391C11.2905 4.30304 10.2002 3.76834 9.02718 3.61895V2.23828H7.69385V3.61895C6.52082 3.76845 5.43063 4.30318 4.59435 5.13922C3.75807 5.97526 3.22302 7.0653 3.07318 8.23828H1.69385V9.57161H3.07318C3.22247 10.7451 3.75728 11.8357 4.59361 12.6723C5.42994 13.5089 6.52043 14.044 7.69385 14.1936V15.5716H9.02718V14.1936C10.2006 14.044 11.2911 13.5089 12.1274 12.6723C12.9638 11.8357 13.4986 10.7451 13.6478 9.57161H15.0272V8.23828ZM8.36051 12.9049C7.56939 12.9049 6.79603 12.6704 6.13823 12.2308C5.48044 11.7913 4.96775 11.1666 4.665 10.4357C4.36225 9.70478 4.28303 8.90051 4.43737 8.12459C4.59171 7.34866 4.97268 6.63593 5.53209 6.07652C6.0915 5.51711 6.80423 5.13615 7.58015 4.98181C8.35608 4.82747 9.16034 4.90668 9.89125 5.20943C10.6222 5.51218 11.2469 6.02487 11.6864 6.68267C12.1259 7.34046 12.3605 8.11382 12.3605 8.90495C12.3593 9.96543 11.9375 10.9821 11.1876 11.732C10.4377 12.4819 9.421 12.9037 8.36051 12.9049Z",
    fill: "#14AE5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon1);
export default __webpack_public_path__ + "static/media/location_icon1.349ab34415150246d45f4b5aea017262.svg";
export { ForwardRef as ReactComponent };